import { Box, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { Link as NextLink } from '@stitch-fix/sf-next';
import styles from './styles.module.scss';
export interface BreadcrumbsProps {
  breadcrumbs: {
    text: string;
    href?: string;
  }[];
}
const Breadcrumbs = ({
  breadcrumbs
}: BreadcrumbsProps) => {
  const {
    ref,
    EventProvider
  } = useViewEvent({
    schema: 'view',
    name: 'breadcrumb'
  });
  return <EventProvider>
      <ResponsiveSection width="xxlarge">
        <Box className={styles.breadcrumbs} ref={breadcrumbs.length > 0 ? ref : null}>
          {breadcrumbs.flatMap(({
          text,
          href
        }, index) => [index > 0 && <Text key={`divider-${text}-${href}`} scale="1">
                /
              </Text>, <Text key={text} className={styles.text} scale="1">
              {href ? <NextLink key={href} underline="inverse" variant="inherit" href={href}>
                  {text}
                </NextLink> : text}
            </Text>])}
        </Box>
      </ResponsiveSection>
    </EventProvider>;
};
export default Breadcrumbs;